var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAusenciaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.08594 8.01562 0 18 0C27.9141 0 36 8.08594 36 18C36 27.9844 27.9141 36 18 36C8.01562 36 0 27.9844 0 18Z",
    fill: "#A8071A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21934 25.391L7.21935 25.391L7.22017 25.3891L8.2639 22.9357H14.73L15.7735 25.3886C15.7736 25.3886 15.7736 25.3886 15.7736 25.3887C15.9664 25.8467 16.4273 26.15 16.9267 26.15C17.0864 26.15 17.2433 26.1106 17.3958 26.0357C18.0056 25.7694 18.3167 25.0494 18.0455 24.4339L12.6332 11.578C12.4383 11.115 11.9739 10.85 11.5139 10.85C11.0227 10.85 10.5566 11.1127 10.3607 11.578L4.94792 24.4351H4.94792L4.94768 24.4357C4.67781 25.0843 4.98891 25.7719 5.60168 26.0372L5.60166 26.0372L5.60467 26.0385C6.2568 26.3042 6.95055 25.999 7.21934 25.391ZM9.27182 20.4594L11.5129 15.2333L13.7233 20.4594H9.27182ZM31.15 19.6049V12.0714C31.15 11.3814 30.5709 10.85 29.9174 10.85C29.2271 10.85 28.6849 11.3844 28.6849 12.0714V19.6049C28.6849 21.8628 26.7929 23.7071 24.5046 23.7071C22.1833 23.7071 20.3244 21.8636 20.3244 19.6049V12.0714C20.3244 11.3814 19.7452 10.85 19.0918 10.85C18.4015 10.85 17.8593 11.3844 17.8593 12.0714V19.6049C17.8593 23.2053 20.8378 26.15 24.5046 26.15C28.1377 26.15 31.15 23.1719 31.15 19.6049Z",
    fill: "#F5F5F5",
    stroke: "#F5F5F5",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusenciaIcon);
export default __webpack_public_path__ + "static/media/AusenciaIcon.4ac4dc890d3eb76fbf6fde7c21c26610.svg";
export { ForwardRef as ReactComponent };